import React from 'react'
import { Button, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { trackLink } from '@fs/zion-analytics'
import { baseUrl } from '@fs/zion-config'
import { useFeatureFlag } from '@fs/zion-flags'
import { isTranslationAvailable } from '@fs/zion-locale'

const hasWindow = typeof window !== 'undefined'

const handleSignIn = (external) => {
  trackLink(null, '/auth/familysearch/login', 'click_action', 'lo_hdr19_sign_in')
  if (hasWindow) {
    window.location.href = `${external ? baseUrl : ''}/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location.href)}`
  }
}

const SignInButton = ({ external, gray, emphasis }) => {
  const { t } = useTranslation()

  return (
    <Button
      emphasis={emphasis}
      id="signInLink"
      onClick={() => handleSignIn(external)}
      color={gray ? 'gray' : undefined}
    >
      {t('common-ui:sign-in.action', 'Sign In')}
    </Button>
  )
}

const CreateAccountButton = ({ external, gray, emphasis }) => {
  const { t } = useTranslation()
  const { isOn } = useFeatureFlag('home_header_signUpText')
  const redirectFlag = useFeatureFlag('header_create_account_redirect_to_guided_tree')

  const getRedirectUrl = () => {
    if (window.location.href.includes('/global') && redirectFlag.isOn) {
      return `?returnUrl=${encodeURIComponent('/tree/guided')}`
    }
    return ''
  }

  return (
    <Button
      to={`${external ? baseUrl : ''}/identity/signup/${getRedirectUrl()}`}
      external
      linkName="lo_hdr19_register"
      data-test-id="hdr_create_account"
      color={gray ? 'gray' : undefined}
      emphasis={emphasis}
    >
      {isOn && isTranslationAvailable('account.sign-up.action')
        ? t('account.sign-up.action', 'Sign Up')
        : t('account.create.action', 'Create Account')}
    </Button>
  )
}

export default function AuthAccount({ external }) {
  const { isOn } = useFeatureFlag('home_header_authButtonPositionUpdate')
  const { isOn: isGray } = useFeatureFlag('home_header_grayAuthButtons')

  if (isOn) {
    return (
      <Row>
        <CreateAccountButton external={external} gray={isGray} />
        <SignInButton external={external} gray={isGray} emphasis="medium" />
      </Row>
    )
  }

  return (
    <Row>
      <SignInButton external={external} gray={isGray} />
      <CreateAccountButton external={external} gray={isGray} emphasis="medium" />
    </Row>
  )
}
